import { createFieldInput, createFieldTextArea } from "../../../../../components/input/template-builder/template-builder.logic";
import { createColumnInput } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import lodash from "lodash";

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.role.name"), dataIndex: "name" }),
        createColumnInput({ title: () => i18n.global.t("model.role.desc"), dataIndex: "desc", width: 200 })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.role.name"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.name, "onUpdate:value": value => (model.name = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}desc`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.role.desc"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        { value: model.desc, "onUpdate:value": value => (model.desc = value), disabled: viewOnly },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => false,
                key: `${prefix}userRoles`,
                label: () => i18n.global.t("model.user.modelName"),
                changeLog: { getValueChildren: ({ record }) => record.refUser?.fullNameTh }
            },
            {
                visible: () => false,
                key: `${prefix}roleResources`,
                label: () => i18n.global.t("model.resource.modelName"),
                changeLog: { getValueChildren: ({ record }) => record.refResource?.name }
            },
            {
                visible: () => false,
                key: `${prefix}roleMenus`,
                label: () => i18n.global.t("model.menu.modelName"),
                changeLog: { getValueChildren: ({ record }) => record.refMenu?.name }
            },
        ]
    });
};
